export default "__VITE_ASSET__BWvxXiQi__"